function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var _require = require('./welcome.template'),
  WelcomeSplashTemplate = _require.WelcomeSplashTemplate,
  WelcomeBuildChoiceTemplate = _require.WelcomeBuildChoiceTemplate,
  WelcomeImportChoiceTemplate = _require.WelcomeImportChoiceTemplate;
var _require2 = require('../script_build'),
  getContractTemplates = _require2.getContractTemplates;
var BUILD_TEMPLATE_IDS = {
  multisig: 'shared-wallet',
  'password-protected': 'secret-vault'
};
var WelcomeOverlay = /*#__PURE__*/function () {
  function WelcomeOverlay(app, mod, mainUi) {
    _classCallCheck(this, WelcomeOverlay);
    this.app = app;
    this.mod = mod;
    this.mainUi = mainUi;
    this.overlay = new SaitoOverlay(app, mod, false, true, false);
    this.overlay["class"] = 'saito-overlay rs-onboarding-overlay';
    this.overlay.clickBackdropToClose = false;
    this.templates = getContractTemplates(mod.opcodes);
    this.step = 'splash';
  }
  return _createClass(WelcomeOverlay, [{
    key: "render",
    value: function render(step) {
      if (step) {
        this.step = step;
      }
      this.showStep(this.step);
    }
  }, {
    key: "showStep",
    value: function showStep(step) {
      this.step = step;
      var html = '';
      switch (step) {
        case 'splash':
          html = WelcomeSplashTemplate();
          break;
        case 'create-build':
          html = WelcomeBuildChoiceTemplate();
          break;
        case 'import-choice':
          html = WelcomeImportChoiceTemplate();
          break;
        default:
          html = WelcomeSplashTemplate();
      }
      this.overlay.show(html, function () {});
      this.applyFullscreenLayout();
      this.attachEvents();
    }
  }, {
    key: "applyFullscreenLayout",
    value: function applyFullscreenLayout() {
      var el = document.getElementById("saito-overlay".concat(this.overlay.ordinal));
      var backdrop = document.getElementById("saito-overlay-backdrop".concat(this.overlay.ordinal));
      if (el) {
        el.classList.add('maximized-overlay', 'rs-onboarding-overlay');
      }
      if (backdrop) {
        backdrop.classList.add('rs-onboarding-overlay-backdrop');
      }
      if (typeof this.overlay.pullOverlayToFront === 'function') {
        this.overlay.pullOverlayToFront();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _root$querySelector,
        _this = this;
      var root = document.querySelector('.rs-onboard-appspace');
      if (!root) {
        return;
      }
      (_root$querySelector = root.querySelector('[data-action="back-splash"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function () {
        _this.showStep('splash');
      });
      root.querySelectorAll('[data-path]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var path = btn.dataset.path;
          if (path === 'create') {
            _this.showStep('create-build');
          } else if (path === 'interact') {
            _this.showStep('import-choice');
          } else if (path === 'expert') {
            _this.enterExpert();
          }
        });
      });
      root.querySelectorAll('[data-build]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var build = btn.dataset.build;
          if (build === 'custom') {
            _this.enterCreateFromScratch();
            return;
          }
          var templateId = BUILD_TEMPLATE_IDS[build];
          var tpl = _this.templates.find(function (t) {
            return t.id === templateId;
          });
          if (tpl) {
            _this.enterCreateGuided(tpl.locking);
          }
        });
      });
      root.querySelectorAll('[data-import]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var kind = btn.dataset["import"];
          if (kind === 'unlock-tx') {
            _this.dismiss('interact');
            _this.mainUi.importFlow.open();
          } else if (kind === 'continue-unlock') {
            _this.dismiss('interact');
            _this.mainUi.continueUnlockImportFlow.open();
          } else if (kind === 'saved-script') {
            _this.dismiss('interact');
            _this.mainUi.scriptImportFlow.open();
          }
        });
      });
    }
  }, {
    key: "enterCreateGuided",
    value: function enterCreateGuided(lockingScript) {
      this.dismiss('create');
      this.mainUi.enterCreateGuided(lockingScript);
    }
  }, {
    key: "enterCreateFromScratch",
    value: function enterCreateFromScratch() {
      this.dismiss('create');
      this.mainUi.enterCreateFromScratch();
    }
  }, {
    key: "enterExpert",
    value: function enterExpert() {
      this.dismiss('expert');
      this.mainUi.enterExpertMode();
    }
  }, {
    key: "dismiss",
    value: function dismiss(entryPath) {
      this.persistEntry(entryPath);
      this.overlay.remove();
    }
  }, {
    key: "persistEntry",
    value: function persistEntry(entryPath) {
      var _this$app$storage;
      this.app.options.rustscript = _objectSpread(_objectSpread({}, this.app.options.rustscript || {}), {}, {
        onboardingComplete: true,
        entryPath: entryPath,
        completedAt: Date.now()
      });
      if (typeof ((_this$app$storage = this.app.storage) === null || _this$app$storage === void 0 ? void 0 : _this$app$storage.saveOptions) === 'function') {
        this.app.storage.saveOptions();
      }
    }
  }]);
}();
WelcomeOverlay.shouldShow = function shouldShow(app) {
  var _app$options;
  var rs = app === null || app === void 0 || (_app$options = app.options) === null || _app$options === void 0 ? void 0 : _app$options.rustscript;
  if (rs !== null && rs !== void 0 && rs.onboardingComplete) {
    return false;
  }
  if (rs !== null && rs !== void 0 && rs.skipOnboarding) {
    return false;
  }
  return true;
};
module.exports = WelcomeOverlay;